import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import axios from "axios";
import React, { useEffect, useState } from "react";
import AlertDialog from "../../AlertDialog";
import { baseUrl, mainBaseUrl } from "../../App";
import "./Lead.scss";

const LeadPage = () => {
  const [open, setOpen] = React.useState(false);
  const [leadData, setleadData] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [openAlert, setopenAlert] = useState(false);
  const [deleteLoading, setdeleteLoading] = useState(false);
  const [addData, setaddData] = useState({
    name: "",
    email: "",
    mobile: "",
    leadTenure: "",
  });

  const title = "Delete Lead";
  const description = "Do you really want to delete lead ?";
  const handleDeleteLeadClose = () => {
    setopenAlert(false);
  };
  // onAgree delte lea

  const handleClose = () => {
    setOpen(false);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    getLead();
  }, []);

  const deleteLead = (id) => {
    setdeleteLoading(true);
    var config = {
      method: "delete",
      url: `${mainBaseUrl}/leads/${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "API-Key": baseUrl,
      },
    };
    axios(config)
      .then(function (response) {
        setdeleteLoading(false);
        setopenAlert(false);
        alert("Lead Deleted Successfully");
      })
      .catch(function (error) {
        alert(error.response.data.message);
        setdeleteLoading(false);
        setopenAlert(false);
      });
  };

  const getLead = () => {
    var config = {
      method: "get",
      url: `${mainBaseUrl}/leads`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "API-Key": baseUrl,
      },
    };

    axios(config)
      .then(function (response) {
        if (response.data.length === 0) {
          setleadData([{ data: "none" }]);
        } else {
          setleadData(response.data);
        }
      })
      .catch(function (error) {
        alert(error.response.data.message);
      });
  };

  const addLead = () => {
    setisLoading(true);
    var data = {
      name: addData.name,
      email: addData.email,
      mobile: addData.mobile,
      leadTenure: addData.leadTenure,
    };

    var config = {
      method: "post",
      url: `${mainBaseUrl}/leads`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "API-Key": baseUrl,
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        // console.log(JSON.stringify(response.data));
        setisLoading(false);
        getLead();
        handleClose();
      })
      .catch(function (error) {
        setisLoading(false);
        // console.log(error);
        handleClose();
      });
  };

  return (
    <div className="leadPage">
      <div className="header">
        <h1>Lead Management</h1>
        <button
          onClick={() => {
            handleClickOpen();
          }}
        >
          Add Lead
        </button>

        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Add New Lead</DialogTitle>

          <DialogContent>
            <TextField
              onChange={(e) => setaddData({ ...addData, name: e.target.value })}
              margin="dense"
              label="Name"
              type="text"
              variant="outlined"
              fullWidth
            />
            <TextField
              onChange={(e) =>
                setaddData({ ...addData, email: e.target.value })
              }
              margin="dense"
              label="Email"
              type="text"
              variant="outlined"
              fullWidth
            />
            <TextField
              onChange={(e) =>
                setaddData({ ...addData, mobile: e.target.value })
              }
              margin="dense"
              label="Mobile Number"
              type="text"
              variant="outlined"
              fullWidth
            />
            <TextField
              onChange={(e) =>
                setaddData({ ...addData, leadTenure: e.target.value })
              }
              margin="dense"
              label="Lead Tenure"
              type="text"
              variant="outlined"
              fullWidth
            />
            <div className="div" style={{ height: "20px" }}></div>
            <Button
              onClick={() => {
                addLead();
              }}
              variant="contained"
              style={{
                backgroundColor: "#200e32",
                color: "white",
              }}
            >
              Add Lead
            </Button>
            <div className="div" style={{ height: "20px" }}></div>
            {isLoading ? <p>Loading...</p> : ""}
            <div className="div" style={{ height: "20px" }}></div>
          </DialogContent>
        </Dialog>
      </div>
      <div className="div" style={{ height: "30px" }}></div>
      {leadData.length == 0 ? (
        <p>LOADING....</p>
      ) : leadData[0]["data"] === "none" ? (
        <p>There's no lead added yet</p>
      ) : (
        <div className="main-container">
          {leadData.map((data) => {
            return (
              <div
                key={data._id}
                className="leadContainer"
                style={{ margin: "10px" }}
              >
                <div className="heading">
                  <p>Name</p>
                  <p>Email</p>
                  <p>Mobile</p>
                  <p>Tenure</p>
                </div>
                <div className="answer">
                  <p>{data.name}</p>
                  <p>{data.email}</p>
                  <p>{data.mobile}</p>
                  <p>{data.leadTenure}</p>
                </div>
                <AlertDialog
                  title={title}
                  onAgree={() => deleteLead(data._id)}
                  description={description}
                  open={openAlert}
                  handleClose={handleDeleteLeadClose}
                  isLoading={deleteLoading}
                />
                <div
                  onClick={() => setopenAlert(true)}
                  style={{ cursor: "pointer" }}
                >
                  <DeleteIcon color={"error"} />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default LeadPage;
